module.exports = __webpack_public_path__ + "static/media/tienda.0969e420.jpg";